import script from "./background.vue?vue&type=script&lang=ts&setup=true"
export * from "./background.vue?vue&type=script&lang=ts&setup=true"

import "./background.vue?vue&type=style&index=0&id=423b4fc6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423b4fc6"]])

export default __exports__